import { TagAction, TagActionTypes } from '@completion/actions';
import { byTagNumber, CheckSheetAssignment, Tag, TagProjection } from '@completion/models';
import { GlobalSearchResponse, TagSearchResponse } from '@completion/services';
import { sortByCheckSheet, sortByTag } from '@completion/utils';

export const initialState: TagState = {
  availableTags: [],
  searchTags: [],
  searchResponse: null,
  globalSearchResponse: null,
  tagProjections: new Map<string, TagProjection>(),
};

export interface TagState {
  availableTags: Tag[];
  searchTags?: CheckSheetAssignment[];
  searchResponse?: TagSearchResponse | null;
  globalSearchResponse?: GlobalSearchResponse | null;
  tagProjections?: Map<string, TagProjection>;
}

export function tagReducer(state: TagState = initialState, action: TagAction): TagState {
  switch (action.type) {
    case TagActionTypes.LoadAvailableTagsSuccess:
      return {
        ...state,
        availableTags: [...action.tags].sort(byTagNumber),
      };
    case TagActionTypes.LoadSearchTagsSuccess:
      const searchTags = [...action.csas].sort((a, b) => sortByTag(a, b) || sortByCheckSheet(a, b));
      return {
        ...state,
        searchTags,
      };
    case TagActionTypes.SearchTagsAllSuccess:
      const sorted = [...action.response.result].sort(
        (a, b) => (a.tagNumber ?? '').localeCompare(b.tagNumber ?? '') || (a.csNumber ?? '').localeCompare(b.csNumber ?? ''),
      );
      return {
        ...state,
        searchResponse: { result: sorted, resultMessage: action.response.resultMessage },
      };
    case TagActionTypes.ClearSearchTagsAll:
      return {
        ...state,
        searchResponse: null,
      };
    case TagActionTypes.GlobalSearchSuccess:
      return {
        ...state,
        globalSearchResponse: action.response,
      };
    case TagActionTypes.ClearGlobalSearch:
      return {
        ...state,
        globalSearchResponse: null,
      };
    case TagActionTypes.LoadTagProjectionsSuccess:
      return {
        ...state,
        tagProjections: new Map(action.projections.map((p) => [p.tagNumber, p])),
      };
    default:
      return state;
  }
}
